import React, { useEffect, useState } from 'react';
import {
	Box,
	Typography,
} from '@mui/material';
import { useLazyQuery } from '@apollo/client';
import { GET_ORDERS_BY_CUSTOMER } from '../../gql/queries';
import { Order } from '../../gql/graphql';
import { GenericTable } from '../generic/generic.table';
import Loader from '../generic/Loader';

interface OrderHistoryTabProps {
	customerId: string;
}

function OrderHistoryTab({ customerId }: OrderHistoryTabProps) {
	const [getOrdersByCustomer, { loading, data }] = useLazyQuery<Record<"ordersByCustomer", Order[]>>(GET_ORDERS_BY_CUSTOMER);
	const [orders, setOrders] = useState<Order[]>([]);

	useEffect(() => {
		if (customerId) {
			getOrdersByCustomer({ variables: { customerId } });
		}
	}, [customerId, getOrdersByCustomer]);

	useEffect(() => {
		if (data?.ordersByCustomer) {
			setOrders(data.ordersByCustomer);
		}
	}, [data]);

	const orderTableColumns = [
		{ key: "sequenceNumber", title: "Bill No." },
		{
			key: "createdAt",
			title: "Date",
			formatter: (_: any, order: Order) => new Date(order.createdAt).toLocaleDateString(),
		},
		{ key: "total", title: "Amount" },
		{ key: "paymentMethod", title: "Payment" },
	];

	if (loading) {
		return <Loader isLoading={true} />;
	}

	return (
		<Box>
			<GenericTable
				title="Order History"
				columns={orderTableColumns}
				data={orders}
				refetch={() => {
					if (customerId) {
						getOrdersByCustomer({ variables: { customerId } });
					}
				}}
			/>
		</Box>
	);
}

export default OrderHistoryTab;
